import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles/order-menu.css'
import { store, persistor } from 'store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import * as Sentry from '@sentry/react'
import Clarity from '@microsoft/clarity'
import App from './App'

// Check if Sentry should be enabled (disabled in development)
const isSentryEnabled =
  process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test'

// Initialize Sentry only in production or staging environments
if (isSentryEnabled) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    tracesSampleRate: 0.1,
    enabled:
      process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test',
  })
}

// Initialize Microsoft Clarity
// Only initialize in production environment
if (process.env.NODE_ENV === 'production') {
  // Replace 'your-project-id' with your actual Clarity project ID from the dashboard
  Clarity.init('rnd8gzqg6t')
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {isSentryEnabled ? (
          <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <App />
          </Sentry.ErrorBoundary>
        ) : (
          <App />
        )}
      </PersistGate>
    </Provider>
  </>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
